/* 🤖 this file was generated by svg-to-ts */
export const iccIconExpandMore: {
  name: 'expand_more';
  data: string;
} = {
  name: 'expand_more',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.59 8.295 12 12.875l-4.59-4.58L6 9.705l6 6 6-6-1.41-1.41Z" fill="currentColor"/></svg>`
};
